import { createFeatureSelector, createSelector } from "@ngrx/store";
import { UserState } from "./profile.state";

export const UserFeatureSelector = createFeatureSelector<UserState>('user');

export const SelectUser = createSelector(
  UserFeatureSelector,
  state => state?.data
)

export const SelectUserStatus = createSelector(
  UserFeatureSelector,
  state => state.login
)